import React from 'react';
import { Message } from 'botframework-directlinejs';
import { mergeClasses } from '@fluentui/react-components';
import { BaseMessage, IBaseMessageProps } from './base-message';

interface IHumanMessageProps extends Omit<IBaseMessageProps, 'isAIMessage'> {
  message: Message;
}

export const HumanMessage: React.FC<IHumanMessageProps> = React.memo((props) => {
  const { message } = props;

  const pluginName = (message.value as any)?.PluginContext?.Name;
  if (pluginName === 'AccountFluctuation' || pluginName === 'CampaignFluctuation') {
    // do not show the automated message to trigger fluctuations
    return null;
  }

  return (
    <BaseMessage
      {...props}
      className={mergeClasses(props.className, 'human-message')}
    >
      <span className="content">{props.message.text}</span>
    </BaseMessage>
  );
});
